import Route from "@ember/routing/route";
import { Changeset } from "ember-changeset";

export default class MedicPasswordForgottenRoute extends Route {
  model(params) {
    // Create the changeset
    const changeset = Changeset({}); // <= do no set the "email" property here

    // Set the "email" property on the changeset from the query params
    // This sets the changeset as dirty and enables the WRForm submit button
    changeset.set("email", params.email);

    return changeset;
  }
}
